import { buildCssClassName, getLinkDecorationTwClasses, getTransitionTwClasses } from "@/3514/utils"

import { type TInfoBoxVariant as TVariant } from "./info-box.types"

const _variantClasses: Record<TVariant, () => string> = {
    warning: (): string =>
        buildCssClassName(
            "relative",
            "flex",
            "flex-col",
            "gap-y-[7px]",
            "bg-red-500",
            "rounded-[10px]",
            "border-[1px]",
            "border-red-200",
            "border-dashed",
            "px-[15px]",
            "pt-[10px]",
            "pb-[20px]"
        ),
    error: (): string => "relative flex flex-col gap-y-[10px] bg-red-400 rounded-[10px] p-[20px]",
    info: (): string => "relative flex flex-col gap-y-[7px] bg-lightblue-600 rounded-[10px] p-[15px]"
}

export default {
    hint: (): string => "inline",
    linkWrapper: (): string => "inline group",
    titleWrapper: (): string => "flex items-center gap-x-[5px]",
    dismissButton: ({ variant }: { variant: TVariant }): string =>
        buildCssClassName(
            "absolute",
            "top-[5px]",
            "right-[5px]",
            "flex",
            "items-center",
            "justify-center",
            "cursor-pointer",
            "!outline-none",
            "rounded-full",
            "border-[1px]",
            "border-transparent",
            { "hover:border-red-200 focus-visible:border-red-200": variant === "warning" },
            { "hover:border-red-200 focus-visible:border-red-200": variant === "error" },
            { "hover:border-lightblue-100 focus-visible:border-lightblue-100": variant === "info" },
            getTransitionTwClasses("all", 200)
        ),
    variants: _variantClasses,
    linkText: (): string =>
        buildCssClassName(
            "cursor-pointer select-none",
            getLinkDecorationTwClasses({ color: "accent", offset: 3, isGroup: true })
        )
}
